<div class="card-info" *ngIf="creditCard">
  <img
    loading="lazy"
    *ngIf="cardFlag"
    [src]="cardFlag"
    class="card-info__flag-card"
  />
  <div class="card-info__data">
    <p *ngIf="creditCardId">
      <b>Credit Card ID:</b> {{ creditCardId }}
    </p>
    <p>
      <b>{{ cardHolder | titlecase }}</b>
    </p>
    <p>
      xxxx xxxx xxxx
      {{ creditCard.lastDigits }}
    </p>
    <p>Válido até: {{ cardExpiration }}</p>
  </div>
</div>

<div class="card-tokens" *ngIf="tokens.length > 0">
  <p class="card-tokens__title">
    Tokens (glam / mmkt) — {{ tokens.length }}
  </p>
  <ul class="card-tokens__list">
    <li class="card-tokens__item" *ngFor="let token of tokens">
      <span
        class="card-tokens__badge"
        [class.card-tokens__badge--ok]="token.hasToken"
        [class.card-tokens__badge--missing]="!token.hasToken"
        [title]="token.hasToken ? 'Com token' : 'Sem token'"
      >
        {{ token.hasToken ? 'OK' : '—' }}
      </span>
      <span class="card-tokens__gateway" [title]="token.gatewayName || 'Sem gateway'">
        {{ token.gatewayName || 'Sem gateway' }}
        <span class="card-tokens__muted" *ngIf="token.gatewayId">#{{ token.gatewayId }}</span>
      </span>
      <span class="card-tokens__bu" [title]="token.businessUnitName || 'Sem BU'">
        {{ token.businessUnitName || 'Sem BU' }}
        <span class="card-tokens__muted" *ngIf="token.businessUnitId">#{{ token.businessUnitId }}</span>
      </span>
      <span class="card-tokens__ids" *ngIf="token.cardIdMasked || token.customerIdMasked">
        <span *ngIf="token.cardIdMasked">card {{ token.cardIdMasked }}</span>
        <span *ngIf="token.customerIdMasked">cust {{ token.customerIdMasked }}</span>
      </span>
    </li>
  </ul>
</div>

<p class="card-tokens__empty" *ngIf="creditCardId && tokens.length === 0">
  Nenhum token em CreditCardToken (glam BU 1 / mmkt BU 2).
</p>
